/**
 * A tamarind leaf drawn as it grows: a gently arched rachis carrying many
 * pairs of small, narrow, slightly asymmetric leaflets that shrink towards
 * the tip, each with its own midrib. Colour comes from `currentColor`, so it
 * can be outlined in gold or tinted in green by CSS.
 */
const PAIRS = 13;
let uid = 0;

const TamarindLeaf = ({ className = '', filled = false, vertical = false }) => {
  uid += 1;
  const id = `tl-g-${uid}`;
  const arch = (x) => 45 - 9 * Math.sin((x / 236) * Math.PI); // stem rises, then settles
  const leaflets = [];
  for (let i = 0; i < PAIRS; i += 1) {
    const x = 16 + i * 16.2;
    const y = arch(x);
    const len = 17.5 - i * 0.68;
    const w = 5.2 - i * 0.2;
    [-1, 1].forEach((side) => {
      const tilt = side * -(58 + ((i * 7 + (side > 0 ? 3 : 0)) % 9) - 4);
      const d = `M0 0 C${len * 0.22} ${-w * 1.05} ${len * 0.74} ${-w * 1.1} ${len} ${w * 0.1} C${len * 0.76} ${w * 0.95} ${len * 0.24} ${w * 0.9} 0 0 Z`;
      leaflets.push(
        <g key={`${i}-${side}`} transform={`translate(${x} ${y}) rotate(${tilt})`}>
          <path d={d} fill={filled ? `url(#${id})` : 'none'} />
          <path d={`M0 0 L${len * 0.9} ${w * 0.05}`} fill="none" strokeWidth="0.7" opacity="0.75" />
        </g>
      );
    });
  }
  const tipX = 16 + PAIRS * 16.2;
  return (
    <svg
      viewBox={vertical ? '0 0 90 252' : '0 0 252 90'}
      className={className}
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="currentColor" stopOpacity="0.55" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.18" />
        </linearGradient>
      </defs>
      <g transform={vertical ? 'translate(0 252) rotate(-90)' : undefined}>
        <path
          d={`M2 ${arch(2) + 1} Q${tipX / 2} 30 ${tipX + 6} ${arch(tipX) - 1}`}
          fill="none"
          strokeWidth="1.8"
        />
        {leaflets}
        <g transform={`translate(${tipX + 4} ${arch(tipX) - 1}) rotate(-8)`}>
          <path d="M0 0 C4 -4 14 -4.6 20 0 C14 4.4 4 4 0 0 Z" fill={filled ? `url(#${id})` : 'none'} />
        </g>
      </g>
    </svg>
  );
};

export default TamarindLeaf;
